import React from 'react';
import PropTypes from 'prop-types';
import './DialogMessage.scss';

const DialogMessage = ({ messages, date }) => (
  <div className="dialog-message">
    <div className="dialog-text">
      {
        !!messages && messages.length > 0 && messages.map((message, index) => <div key={index} className="message">{message}</div>)
      }
    </div>
    {
      !!date && <div className="date">{date}</div>
    }
  </div>
);

DialogMessage.propTypes = {
  messages: PropTypes.array,
  date: PropTypes.string,
};

export default DialogMessage;
